<template>
	<div class="full" id="summaryTrendChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	import ecStat from 'echarts-stat';
	import * as ss from 'simple-statistics'
	export default {
		props: {
			date: {
				default: () => {
					return ''
				}
			},
			trendData: {
				default: () => {
					return []
				}
			},
			formData: {
				default: () => {
					return null
				}
			},


			chartField: {
				default: () => {
					return 'realPayAmt1d'
				}
			},
			chartTitle: {
				default: () => {
					return '净销售额'
				}
			}
		},
		data() {
			return {
				chart:null,

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.statisticsChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				this.trendChart()
			},
			trendChart() {
				let field = this.chartField
				//let title = this.chartTitle
				let series = []
				let shopname = []
				let trendData = JSON.parse(JSON.stringify(this.trendData))
				trendData = this.groupByField(trendData, 'shopname')
				for (let i in trendData) {
					shopname.push(i)
					let data = []
					trendData[i].forEach((item) => {
						data.push(parseFloat(item[field]))
					})
					let min = ss.min(data)
					let max = ss.max(data)
					let normalizedData = data.map(function(value) {
						return (value - min) / (max - min)
					})
					//let normalizedData = this.standardize(data)
					data = []
					normalizedData.forEach((item, index) => {
						data.push([index, item])
					})

					let linedata = ecStat.regression('linear', data)
					series.push({
						symbolSize: 1,
						name: i,
						data: data,
						type: 'scatter'
					}, {
						name: i,
						type: 'line',
						smooth: true,
						data: linedata.points,
						symbolSize: 0.1,
						symbol: 'circle'
					})
				}


				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('summaryTrendChart'))
				}
				this.chart.setOption({
					title: {
						text: this.date.join('~'),
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: shopname
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					// tooltip: {
					// 	trigger: 'axis',
					// 	axisPointer: {
					// 		type: 'shadow'
					// 	}
					// },
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {},
					yAxis: {},
					series: series
				})
			},
			groupByField(arr, field) {
				return arr.reduce(function(acc, obj) {
					var key = obj[field];
					if (!acc[key]) {
						acc[key] = [];
					}
					acc[key].push(obj);
					return acc;
				}, {});
			}
		},
		components: {

		}
	}
</script>